const doc = [({"da":({"js":({"reimbursements":({"create_card":({"extended_form":({"save_button":({"save":"Gem"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;